import palette from '../palette';

export default {
  root: {
    height: '8px',
    background: 'red',
    borderRadius: '4px',
  },
  colorPrimary: {
    background: `${palette.success.main} !important`,
  },
  barColorPrimary: {
    background: `${palette.disabled.main} !important`,
  },
};